<template>
  <v-container class="container_wrap edit_offer" style="padding-left: 0; padding-right: 10px;">
    <v-row class="text-center title">
      <v-col cols="8">
        <h1 class="titleOfferAggregated">Edit Aggregated Offer</h1>
      </v-col>
      <v-col cols="1">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <span
                  v-bind="attrs"
              >
                <label class="editMode" v-show="checkEditMode()">
                    <i class="fas fa-exclamation-triangle" data-fa-transform="shrink-2"></i>
                </label>
              </span>
          </template>
          <span>You have unsaved changes</span>
        </v-tooltip>

      </v-col>
      <v-col cols="3">
        <b-button v-show="checkEditMode()" class="btn-cancel-edit margin-right-10" @click="this.cancelEdit">
          <i class="fas fa-ban" data-fa-transform="shrink-2"></i> Cancel
        </b-button>
        <b-button class="btn-save btn-primary" @click="this.saveOfferAggregated">
          SAVE
        </b-button>
      </v-col>
    </v-row>

    <div id="edit-offer">
      <v-row class="text-center title">
        <v-col cols="2">
          <div class="condition__controls">
            <label>ID</label>
            <input type="text"
                   class="condition__matches campaign custom-input offer-id"
                   :value="id"
                   disabled
            >
          </div>
        </v-col>
        <v-col cols="2" style="margin-left: -120px">
          <div class="condition__controls">
            <label>ExternalId</label>
            <input type="text"
                   :value="getOffer.externalId"
                   class="condition__matches campaign custom-input offer-external-id"
                   :id="defineId(`externalId`,id)"
                   @change="updValue($event, `externalId`)"
                   maxlength="20"
            >
          </div>
        </v-col>
        <v-col cols="4">
          <div class="condition__controls">
            <label>Name</label>
            <input type="text"
                   placeholder="ex: iPhone 11"
                   :value="getOffer.name"
                   class="condition__matches campaign custom-input offer-name"
                   :id="defineId(`offerName`,id)"
                   @change="updValue($event, `name`)"
                   maxlength="120"
            >
          </div>
        </v-col>
        <v-col cols="4">
          <div class="condition__controls">
            <label>Offer Manager</label>
            <select
                :id="defineId(`advertiserManagerId`,id)"
                class="condition__dimension-name condition__matches custom-select"
                @change="updValue($event, `advertiserManagerId`)"
            >
              <option :value="null"></option>
              <option
                  v-for="{id, firstName, lastName} in getSflAdvertisersManagers"
                  :selected="id === getOffer.advertiserManagerId "
                  :key="id"
              >{{ firstName }} {{ lastName }}
              </option>
            </select>
          </div>
        </v-col>
      </v-row>

      <v-row class="text-center offer-tabs">
        <b-tabs content-class="mt-3">
          <b-tab title="General" active>
            <v-row class="text-center offer-description">
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Description (public)</label>
                  <b-form-textarea
                      id="textarea"
                      placeholder="Description or notes about this offer..."
                      rows="3"
                      max-rows="4"
                      :value="getOffer.descriptions"
                      @change="updValue($event, `descriptions`)"
                  ></b-form-textarea>
                </div>
              </v-col>
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Restrictions (public)</label>
                  <b-form-textarea
                      id="textarea"
                      placeholder="Restrictions or notes about this offer..."
                      rows="3"
                      max-rows="4"
                      :value="getOffer.restrictions"
                      @change="updValue($event, `restrictions`)"
                  ></b-form-textarea>
                </div>
              </v-col>
              <v-col cols="md-4 sm-12">
                <div class="condition__controls">
                  <label>Notes (private)</label>
                  <b-form-textarea
                          id="textarea"
                          placeholder="Internal notes about this offer..."
                          rows="3"
                          max-rows="4"
                          :value="getOffer.internalNotes"
                          @change="updValue($event, `internalNotes`)"
                  ></b-form-textarea>
                </div>
              </v-col>
            </v-row>

            <v-row class="text-center general_tab">
              <v-col cols="4">
                <div class="condition__controls">
                  <label>Advertiser</label>

                  <select
                      :id="defineId(`advertiser`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `advertiserId`)"
                      disabled
                  >
                    <option :value="null">-- Select advertiser --</option>
                    <option
                        v-for="{id, name} in getSflAdvertisers"
                        :selected="id === getOffer.advertiserId "
                        :key="id"
                        disabled
                    >{{ name }}
                    </option>

                  </select>
                </div>
              </v-col>

              <v-col cols="4">
                <div class="condition__controls">
                  <label>Vertical</label>
                  <select
                      :id="defineId(`verticalId`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `verticalId`)"
                  >
                    <option :value="null">-- Select verticals --</option>
                    <option
                        v-for="{id, name} in getVerticals"
                        :selected="id === getOffer.verticalId"
                        :key="id"
                    >{{ name }}
                    </option>
                  </select>
                </div>
              </v-col>

              <v-col cols="4">
                <div class="condition__controls">
                  <label>Status</label>
                  <select
                      :id="defineId(`offerStatus`,id)"
                      class="condition__dimension-name condition__matches custom-select"
                      @change="updValue($event, `status`)"
                      :disabled="getOffersAggregated.length === 0 || this.isRestricted"
                  >
                    <option
                        id="filterType"
                        v-for="{id, name} in getStatusList()"
                        :selected="formatStr(name) === formatStr(getOffer.status || '')"
                        :key="id"
                        :disabled="getOffersAggregated.length === 0"
                    >{{ name }}
                    </option>
                  </select>
                </div>
              </v-col>

              <v-col cols="6">
                <div class="campaign-block condition__controls">
                  <label for="label-platform" style="float:none">Conversion Flow Type</label>
                  <div class="btn-group btn-group-toggle flex row wrap aggregatedOfferGrid" data-toggle="buttons">

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              type="radio"
                              :checked="checkConversionType(`cpi`)"
                              name="radio"
                              @change="updValue(`cpi`, `conversionType`)"
                          >
                          CPI <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per install</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              type="radio"
                              :checked="checkConversionType(`cpa`)"
                              @change="updValue(`cpa`, `conversionType`)"
                              name="radio"
                          >
                          CPA <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per action</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              type="radio"
                              :checked="checkConversionType(`cpc`)"
                              @change="updValue(`cpc`, `conversionType`)"
                              name="radio"
                          >
                          CPC <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per click</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                              v-bind="attrs"
                              type="radio"
                              :checked="checkConversionType(`cps`)"
                              @change="updValue(`cps`, `conversionType`)"
                              name="radio"
                          >
                          CPS <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per sale</span>
                      </v-tooltip>
                    </label>

                    <label class="conversionType btn btn-secondary-">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <input
                                  v-bind="attrs"
                                  type="radio"
                                  :checked="checkConversionType(`cpr`)"
                                  @change="updValue(`cpr`, `conversionType`)"
                                  name="radio"
                          >
                          CPR <span class="conversionTypeCheckMark"></span>
                        </template>
                        <span>Cost per registration</span>
                      </v-tooltip>
                    </label>
                  </div>

                </div>
              </v-col>

              <v-col cols="2" v-show="checkConversionType(`revShare`)">
                <div class="condition__controls percentage">
                  <label>RevShare Payout</label>
                  <input type="number"
                         class="condition__matches campaign custom-input payoutPercent"
                         :value="getOffer.payoutPercent"
                         @change="updValue($event, `payoutPercent`)"
                         v-show="checkConversionType(`revShare`)"
                         step=1
                         min="0"
                         max="999"
                         onkeypress="
                                          return (
                                              event.charCode == 8
                                              || event.charCode == 0
                                              || event.charCode == 13
                                          ) ? null : event.charCode >= 48 && event.charCode <= 57"
                         onpaste="return false"
                  >
                </div>
              </v-col>

              <v-col cols="2" v-show="checkConversionType(`hybrid/multistep`)">
                <div class="condition__controls">
                  <label>&nbsp;</label>
                  <b-form-checkbox
                      size="lg"
                      type="checkbox"
                      class="condition__matches campaign"
                      :checked="!!getOfferField(`isCpmOptionEnabled`)"
                      @change="updValue($event, `isCpmOptionEnabled`)"
                      v-show="checkConversionType(`hybrid/multistep`)"
                  >
                    Enable CPM Option
                  </b-form-checkbox>
                </div>
              </v-col>
            </v-row>

            <v-col cols="2">
            </v-col>
            <v-row v-if="user[0].can('edit_payin_payout')">
              <v-col cols="1">
                <v-text-field
                        :rules="[rules.float]"
                        :value="getOffer.payoutPercent"
                        label="Margin %"
                        @change="updValue($event, `payoutPercent`)"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-center defaultsettings">
              <v-col cols="6">
                <div class="condition__controls">
                  <span style="opacity: 0">&nbsp;.</span>
                  <span class="label">Exit Traffic
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <button
                              v-bind="attrs"
                              class="question"
                          >
                            <i class="fad fa-question-circle"></i>
                          </button>
                        </template>
                        <span>Traffic to send out if there is a redirect</span>
                      </v-tooltip>
                    </span>
                  <model-select
                      :options="getOffersModify()"
                      :id="defineId(`aggregatedOfferIdRedirect`,id)"
                      placeholder="Search landing page..."
                      :value="getOffer.offerIdRedirect"
                      @input="updValue($event,`offerIdRedirect`)"
                  >
                  </model-select>
                </div>
              </v-col>
              <v-col cols="6">
              </v-col>
            </v-row>
            <v-col cols="6" v-if="user[0].can('manage_restricted_offers')">
              <div class="condition__controls">
                <div class="is_restricted_text">Restricted Offer</div>
                <v-switch v-model="isRestricted" class="is_restricted_switch"></v-switch>
              </div>
            </v-col>
            <v-row>
              <v-col cols="6" sm="6">
                <FileManager ref="fileUploader" :offerId="getOffer.id"/>
              </v-col>
            </v-row>
          </b-tab>

          <b-tab title="Aggregated">
            <v-row class="text-center defaultsettings">
              <v-col cols="6">
                <v-card
                    color="lighten-2"
                    white
                >
                  <v-card-title class="searchOfferAggregated">
                    Search for Offers
                  </v-card-title>

                  <v-card-text>
                    <v-autocomplete
                        v-model="offerCurrent"
                        :items="offersItems"
                        :search-input.sync="searchOffer"
                        color="white"
                        hide-no-data
                        item-text="offerText"
                        item-value="id"
                        hide-selected
                        label="Offers"
                        placeholder="Start typing to Search"
                        prepend-icon="mdi-database-search"
                        return-object
                    ></v-autocomplete>
                  </v-card-text>
                  <v-card-actions>
                    <b-button
                        :disabled="!offerCurrent"
                        class="btn-save btn-primary"
                        @click="addOfferAggregated_(offerCurrent)"
                    >
                      <i class="fas fa-save" data-fa-transform="shrink-2"></i> add offer
                    </b-button>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="text-center aggregatedOfferGrid">
              <v-data-table
                  :headers="offersAggregatedHeader"
                  :items="this.getOffersAggregated"
                  :items-per-page="10"
                  class="elevation-1 items-size-45"
              >
                <template v-slot:item.name="{item}">
                  <span class="td_title">
                     <a class="entity-link" @click="showCard(item)">{{ item.name }}</a>
                  </span>
                </template>

                <template v-slot:item.actions="{ item }">
                  <button
                      @click="delOfferAggregated_(item.id)"
                      class="td_title btn btn-link"
                  >
                    <i class="far fa-trash"></i>
                  </button>
                </template>
              </v-data-table>
            </v-row>
          </b-tab>

          <b-tab title="History">
            <table class="table table-striped child-row tableFixHead lp-table no-border">
              <thead>
              <tr scope="row">
                <th scope="col">User (E-mail)</th>
                <th scope="col">Date/Time</th>
                <th scope="col">Action</th>
                <th scope="col">Changes</th>
              </tr>
              </thead>
              <tr scope="row" v-for="(history, index) in getOfferHistoryModify() " :key="index">
                <td class="text-center">
                  <span>{{ history.user }}</span>
                </td>
                <td class="text-center">
                  <span>{{ formatDate_(new Date(history.dateAdded * 1000)) }}</span>
                </td>
                <td class="text-center">
                  <span>{{ history.action }}</span>
                </td>
                <td class="text-left" style="padding-left: 15% !important;">
                  <HistoryLog :logsString='history.logs' ></HistoryLog>
                </td>
              </tr>
            </table>
          </b-tab>
        </b-tabs>
      </v-row>
    </div>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import {formatData, cloneObjectArray} from '../../../../helpers'
import {ModelSelect} from 'vue-search-select'
import MainLayout from "../../../layouts/MainLayout"
import store from "../../../../store";
import HistoryLog from "@/components/common/HistoryLog";
import FileManager  from "@/components/common/FileManager";

export default {
  name: 'editOfferAggregated',
  components: {
    ModelSelect,
    MainLayout,
    HistoryLog,
    FileManager
  },
  computed: {
    ...mapGetters('offer', [
      'getOffer',
      'getOffersAggregated',
      'getOffersAggregatedOrigin',
      'getOfferOrigin',
      'getOfferCap',
      'getOfferCapOrigin',
      'getOfferGeo',
      'getOfferGeoOrigin',
      'getCustomLPRules',
      'getCustomLPRulesOrigin',
      'getExitTrafficOffers'
    ]),
    ...mapGetters('offerHistory', ['getOfferHistory']),
    ...mapGetters('lpOffers', ['getLpOffers', 'getLpOffersOrigin']),
    ...mapGetters('countries', ['getCountries']),
    ...mapGetters('advertisers', ['getSflAdvertisers', 'getSflAdvertisersManagers']),
    ...mapGetters('verticals', ['getVerticals']),
    ...mapState('user', ['user']),
  },
  watch: {
    searchOffer(val) {

      // if (this.getOffers.data.length !== 0) {
      //   let listOfAggregatedOffer = this.getOffersAggregated.map(i => (i.id))
      //   this.offersItems = this.getOffers.data
      //       .filter(i => !listOfAggregatedOffer.includes(i.id))
      //       .map(item => (
      //           {
      //             id: item.id,
      //             offerText: `${item.name} (Offer ID: ${item.id})`
      //           }))
      //       .filter(i => (i.includes(val)))
      // }
    },
    isRestricted: async function () {
      await this.updOffer({fieldName: 'isRestricted', value: this.isRestricted})
      let status = this.isRestricted ? 'private' : 'public'
      await this.updOffer({fieldName: 'status', value: status})
    },
  },
  async created() {
    if (!this.user[0].can('manage_offers')){
      await this.$router.push('/403');
    }
  },
  async mounted() {
    this.loading = true
    document.title = `Aggregated Offer-${this.$route.params.id}`;
    await this.$store.dispatch('offer/saveExitTrafficOffersStore')
    await this.$store.dispatch('offer/saveOfferStore', this.id)
    await this.$store.dispatch('offer/saveOfferAggregatedStore', this.id)

    if (this.getOffer.id === null){
      await this.$router.push('/403');
    }

    await this.$store.dispatch('advertisers/saveSflAdvertisersStore', {
      limit: 25,
      page: 1,
      orderBy: 'id',
      orderDirectionAsc: false,
      filters: {status: '\'active\''}
    })
    await this.$store.dispatch('advertisers/saveSflAdvertisersManagersStore')
    await this.$store.dispatch('verticals/saveVerticalsStore')
    await this.$store.dispatch('countries/saveCountriesStore')
    await this.$store.dispatch('offerHistory/saveOfferHistoryStore', this.id)
    this.loading = false
    this.syncOffersWithAggregated()
    this.updAggregatedAdvertiser()
    this.updAggregatedStatus()
    this.isRestricted = this.getOffer.isRestricted
  },
  methods: {
    ...mapMutations('offer', ['updOffer', 'addOfferAggregated', 'delOfferAggregated']),
    ...mapMutations('countries', ['filterCountry']),
    addOfferAggregated_(data) {
      let newOfferToAggregate = this.getExitTrafficOffers.filter(i => i.id === data.id)
      this.addOfferAggregated(newOfferToAggregate[0])
      this.offerCurrent = null
      this.syncOffersWithAggregated()
      this.updAggregatedAdvertiser()
      this.updAggregatedStatus()
    },
    updAggregatedAdvertiser() {
      if (this.getOffersAggregated.length === 0) return
      const advertiserIds = this.getOffersAggregated.map(i => (i.advertiserId))
      const allEqual = arr => arr.every(v => v === arr[0])
      let advertiserIdIdentify = 0
      let advertiserNameIdentify = ''
      if (allEqual(advertiserIds)) {
        advertiserIdIdentify = advertiserIds[0]
        const adv = this.getSflAdvertisers.filter(i => (i.id === advertiserIdIdentify))
        if (adv && adv.length) {
          advertiserNameIdentify = adv[0].name
        }

      } else {
        const advId = this.getSflAdvertisers.filter(i => (i.name === 'Various Publishers'))
        if (advId && advId.length) {
          advertiserIdIdentify = advId[0].id
          advertiserNameIdentify = advId[0].name
        }

      }
      const objAdv = {}
      objAdv.fieldName = `advertiserId`
      objAdv.value = advertiserIdIdentify
      this.updOffer(objAdv)
      objAdv.fieldName = `advertiserName`
      objAdv.value = advertiserNameIdentify
      this.updOffer(objAdv)
    },
    updAggregatedStatus(){
      if (this.getOffersAggregated.length ===0 ){
        const statusUpd = {}
        statusUpd.fieldName = `status`
        statusUpd.value = 'draft'
        this.updOffer(statusUpd)
      }
    },
    delOfferAggregated_(id) {
      this.delOfferAggregated(id)
      this.syncOffersWithAggregated()
      this.updAggregatedAdvertiser()
      this.updAggregatedStatus()
    },
    syncOffersWithAggregated() {
      if (this.getExitTrafficOffers.length !== 0) {
        let listOfAggregatedOffer = this.getOffersAggregated.map(i => (i.id))
        this.offersItems = this.getExitTrafficOffers
            .filter(i => !listOfAggregatedOffer.includes(i.id))
            .map(item => (
                {
                  id: item.id,
                  offerText: `${item.name} (${item.id})`
                }))
      }
    },
    updStartDate(date) {
      this.updValue(date, 'startDate')
      this.starDateMenu = false
    },
    updEndDate(date) {
      this.updValue(date, 'endDate')
      this.endDateMenu = false
    },
    checkEditMode() {
      if (JSON.stringify(this.getOfferOrigin) !== JSON.stringify(this.getOffer)
          || JSON.stringify(this.getOffersAggregatedOrigin) !== JSON.stringify(this.getOffersAggregated)
      ) {
        return true
      }
    },
    getOfferHistoryModify() {
      return this.getOfferHistory.length !== 0 && this.getOfferHistory
    },
    getOffersModify() {
      return this.getExitTrafficOffers.filter(i => i.id !== this.id).map(item => {
        item.value = item.id
        item.text = `${item.name} (Offer ID: ${item.id})`
        return item
      })
    },
    getOfferField(name) {
      if (this.getOffer.length !== 0) {
        return this.getOffer[name]
      }
    },
    updValue(event, name) {
      let obj = {}

      if (
          name === 'conversionType'
          || name === 'defaultLp'
          || name === 'descriptions'
          || name === 'restrictions'
          || name === 'internalNotes'
          || name === 'startDate'
          || name === 'endDate'
          || name === 'offerIdRedirect'
      ) {
        obj.fieldName = name
        obj.value = event
      } else if (name === 'status') {

        obj.fieldName = name
        if (event.target.value.toLowerCase() === 'apply to run') {
          obj.value = `apply_to_run`
        } else {
          obj.value = event.target.value.toLowerCase()
        }

      } else {
        obj.fieldName = name
        if (name === 'isCpmOptionEnabled') {
          obj.value = Number(!this.getOfferField(`isCpmOptionEnabled`))
        } else if (name === 'useStartEndDate' || name === 'payoutPercent') {
          obj.value = !event.length ? null : Number(event);
          if(isNaN(obj.value) && obj.value !== null) return;
        } else {
          obj.value = event.target.value
        }
      }
      if (name === 'advertiserId') {
        let objAdv = {}
        objAdv.fieldName = `advertiserName`
        objAdv.value = event.target.value
        this.updOffer(objAdv)
        let advId = this.getSflAdvertisers.filter(i => (i.name === event.target.value))

        obj.value = advId[0].id
      }

      if (name === 'verticalId') {
        let objAdv = {}
        objAdv.fieldName = `verticalName`
        objAdv.value = event.target.value
        this.updOffer(objAdv)
        let advId = this.getVerticals.filter(i => (i.name === event.target.value))

        obj.value = advId[0].id
      }


      if (name === 'advertiserManagerId') {
        let advManagerId = this.getSflAdvertisersManagers.find(i => (`${i.firstName} ${i.lastName}` === event.target.value))
        obj.value = advManagerId.id
      }

      if (name === 'currencyId') {
        let currency = event.target.value
        let currencyId = this.getCurrencyList().filter(i => (i.name === currency))
        obj.value = currencyId[0].id
      }

      this.fastLpAdd = false
      this.updOffer(obj)
    },
    async cancelEdit() {
      let confirmCancelEdit = await this.$dialog.warning({
        text: `Are you sure?`,
        title: 'Your changes will be discarded.'
      })
      if (confirmCancelEdit) {
        await this.$router.push("/advertisers/offers")
      }
    },
    async saveOfferAggregated() {
      let offerData = this.getOffer
      this.$refs.fileUploader.send();
      offerData.offerAggregatedIds = this.getOffersAggregated.map(i => i.id)
      let emptyKey = []
      let keys = Object.keys(offerData)
      keys.forEach(key => {
        if (
            key === 'payOut' ||
            key === 'payIn' ||
            key === 'useStartEndDate' ||
            key === 'customLPRules' ||
            key === 'descriptions' ||
            key === 'defaultLp' ||
            key === 'geoRules' ||
            key === 'payoutPercent' ||
            key === 'restrictions' ||
            key === 'isCpmOptionEnabled' ||
            key === 'startDate' ||
            key === 'endDate' ||
            key === 'internalNotes' ||
            key === 'offerIdRedirect'
        ) {
          return
        }
        if (Number(offerData[key]) === 0) {
          emptyKey.push(key)
        }
      })


      // if (emptyKey.length !== 0) {
      //   await this.$dialog.error({
      //     text: `${JSON.stringify(emptyKey)} is empty`,
      //     title: 'Validation Error'
      //   })
      //   return
      // }

      const {id} = await this.$store.dispatch('offer/saveOfferAggregatedDb', offerData)
      if (id) {
        const res = await this.$dialog.info({
          text: 'Offer aggregated updated',
          title: 'Info'
        })
      } else {
        await this.$dialog.error({
          text: `Offer aggregated failed to save`,
          title: 'Please check backend errors'
        })
      }


    },
    showCard(item) {
      store.dispatch('cards/ADD', {
        type: 'offer',
        title: `[${item.id}] - [${item.name}] : [${item.status}]`,
        key: `offer-${item.id}`,
        data: item
      })
    },
    checkConversionType(str) {
      let offer = this.getOffer
      if (offer.length !== 0 && offer.conversionType === str) {
        return `checked`
      }
    },
    formatDate_(date) {
      return formatData(date)
    },
    formatStr(str) {
      return str && str.toLowerCase().replace(/_/g, '').replace(/\s/g, '')
    },
    defineId(name, id) {
      return `${name}-${id}`
    },
    getCurrencyList() {
      return [
        {id: 1, name: 'USD'},
        {id: 2, name: 'EUR'},
        {id: 3, name: 'BRL'},
        {id: 4, name: 'GBP'},
      ]
    },
    getStatusList() {
      return [
        {id: 0, name: 'Public'},
        {id: 1, name: 'Private'},
        {id: 2, name: 'Apply to Run'},
        {id: 3, name: 'Inactive'},
        {id: 4, name: 'Draft'},
      ]
    },
  },
  data() {
    return {
      tab: null,
      loading: false,
      rules: {
        required: value => !!value || this.marginRequiredError,
        float: value => {
          if(value && value.length === 0) return true
          const pattern = /^([+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)|^$)$/
          return pattern.test(value) || 'Invalid value'
        }
      },
      offersAggregatedHeader: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'advertiserName', value: 'advertiserName'},
        {text: 'landingPageId', value: 'landingPageId'},
        {text: 'landingPageUrl', value: 'landingPageUrl'},
        {text: 'verticalName', value: 'verticalName'},
        {text: 'payOut', value: 'payOut'},
        {text: 'payIn', value: 'payIn'},
        {text: 'status', value: 'status'},
        {text: 'Actions', value: 'actions', align: 'center'},
      ],
      offersItems: [],
      offersItemActive: 0,
      offerCurrent: null,
      searchOffer: null,
      fastLpAdd: false,
      fastLpValue: '',
      id: Number(this.$route.params.id),
      selected: true,
      payoutType: '1',
      payoutTypeGEO: '1',
      startDate: null,
      endDate: null,
      starDateMenu: false,
      endDateMenu: false,
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: 'MM/DD/YYYY h:mm:ss',
        useCurrent: true,
        showClear: true,
        showClose: false,
        sideBySide: true,
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-chevron-up',
          down: 'fas fa-chevron-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'fas fa-calendar-check',
          clear: 'far fa-ban',
          close: 'far fa-times-circle'
        },
      },
      checkedStartDate: false,
      checkedEndDate: false,
      isRestricted: false,
    };
  }
};

</script>

<style lang="sass">
.aggregatedOfferGrid
  padding: 15px

.titleOfferAggregated
  color: #36B8E1
  font-size: 16px
  font-weight: 700

.searchOfferAggregated
  color: #36B8E1
  font-size: 16px
  font-weight: 700
  background-color: #fff

#edit-offer
  label.custom-control-label
    margin-top: 15px

  .conversionType
    display: table-cell
    position: relative
    padding-left: 35px
    margin-bottom: 10px
    cursor: pointer
    font-size: 16px
    border: 2px solid #E3EEF4
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none

  .conversionType input
    position: absolute
    opacity: 0
    cursor: pointer

  .conversionTypeCheckMark
    position: absolute
    top: 15px
    left: 15px
    height: 10px
    width: 10px
    background-color: #E3EEF4
    border-radius: 50%

  .conversionType:hover input ~ .conversionTypeCheckMark
    background-color: #ccc

  .conversionType input:checked ~ .conversionTypeCheckMark
    background-color: #36B8E1 !important

  .conversionTypeCheckMark:after
    content: ""
    position: absolute
    display: none

  .conversionType input:checked ~ .conversionTypeCheckMark:after
    display: block

  .conversionType .conversionTypeCheckMark:after
    top: 6px
    left: 6px
    width: 8px
    height: 8px
    border-radius: 50%
    background: transparent

  .conversionType:active
    color: #36B8E1
    border-color: #36B8E1
    z-index: 2

  .conversionType.btn.btn-secondary-:focus-within
    color: #36B8E1
    border-color: #36B8E1
    z-index: 2

  .row.text-center.title
    // position: fixed
    // top: 27px
    z-index: 4
    width: 100%
  // margin-left: 20px

  button.btn.btn-cancel-edit, button.btn.btn-save
    position: initial
    float: left
    width: auto
    padding: 0px 20px
    margin-right: 10px

  .title
    .condition__controls label
      font-size: 14px
      display: inline-block
      text-align: left
      color: #7F98A5
      font-weight: 500
      letter-spacing: 0.3px
      margin-top: 5px
      border-radius: 7px
      float: left

  span.label
    font-size: 14px
    display: inline-block
    text-align: left
    color: #7F98A5
    font-weight: 500
    letter-spacing: 0.3px
    margin-top: 5px
    margin-bottom: 5px
    border-radius: 7px

  .row.text-center.title .col-2
    -ms-flex: 0 0 18%
    flex: 0 0 18%
    max-width: 18%

  .row.text-center.title .col-3
    -ms-flex: 0 0 22%
    flex: 0 0 22%
    max-width: 22%

  .row.text-center.title .custom-input
    position: initial
    width: auto
    color: #7F98A5
    font-size: 16px
    font-weight: 600
    border-radius: 7px
    padding: 10px 15px
    height: 40px
    text-align: left
    border: 2px solid #e3eef4
    margin-left: 10px
    float: left

    &.offer-id
      width: 100px

    &.offer-name
      width: 240px
      text-overflow: ellipsis

  .row.text-center.title .custom-select
    text-align: left
    position: relative
    min-width: 140px
    width: auto
    height: 40px
    border-radius: 7px
    color: #7F98A5
    font-size: 16px
    font-weight: 600
    border: 2px solid #e3eef4
    margin-left: 10px
    float: left
    text-overflow: ellipsis

  .row.text-center.title .condition__controls
    border: 0
    margin-top: -1rem
    margin-bottom: 0rem
    padding-bottom: 0rem

  .row.text-center.title .condition__matches
    margin-right: 0px

  .offer-tabs
    margin-top: 20px

  .basil
    background-color: transparent !important

  .basil--text
    color: #3A3852 !important

  .tabs
    width: 100%

    .tab-content
      max-width: 95vw

    .mt-3, .my-3
      margin-top: 0rem !important
      background: #fff
      padding: 20px
      border-left: 2px solid #E3EEF4
      border-right: 2px solid #E3EEF4
      border-bottom: 2px solid #E3EEF4
      border-radius: 0px 0px 4px 4px

    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link
      color: #36B8E1
      font-size: 16px
      font-weight: 700
      background-color: #fff
    // border: 2px solid #E3EEF4

    .nav-tabs
      border-bottom: 2px solid #E3EEF4

    .nav-link
      color: #7F98A5
      font-size: 16px
      font-weight: 500
      margin-left: 0px
      margin-bottom: -2px
      padding: 10px 5rem

    .percentage::before
      content: '\F541'
      font-family: "Font Awesome 5 Free"
      font-weight: 900
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: right
      position: relative
      top: 42px
      right: 15px
      z-index: 1

    .bottom.percentage::before
      top: 37px

    .dollar::before
      content: '\f155'
      font-family: "Font Awesome 5 Free"
      font-weight: 900
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: left
      position: relative
      top: 43px
      left: 15px
      z-index: 1

    .bottom.dollar::before
      top: 37px

    .euro::before
      content: '\f153'
      font-family: "Font Awesome 5 Free"
      font-weight: 900
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: left
      position: relative
      top: 43px
      left: 15px
      z-index: 1

    .bottom.euro::before
      top: 37px

    .brl::before
      content: 'R\f155'
      font-family: "Font Awesome 5 Free"
      font-weight: 900
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: left
      position: relative
      top: 43px
      left: 15px
      z-index: 1

    .bottom.brl::before
      top: 37px

    .gbr::before
      content: '\f154'
      font-family: "Font Awesome 5 Free"
      font-weight: 900
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: left
      position: relative
      top: 43px
      left: 15px
      z-index: 1

    .bottom.gbr::before
      top: 37px


    input.condition__matches.payIn, input.condition__matches.payOut
      padding-left: 40px

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button
      -webkit-appearance: none
      margin: 0

    input[type=number]
      -moz-appearance: textfield

    input.form-control.custom-input.date-picker
      font-size: 16px
      border: 2px solid #E3EEF4
      border-radius: 4px
      padding: 5px 10px 5px 40px
      margin-top: 0px

    span.datepicker::before
      content: '\f073'
      font-family: "Font Awesome 5 Free"
      font-weight: 300
      font-size: 18px
      color: #ACC3CF
      opacity: 0.7
      float: left
      position: relative
      margin-top: -15px
      top: 34px
      left: -108px
      z-index: 1

    span.oldValue
      color: #ACC3CF
      font-weight: 400
      text-decoration: line-through
      margin-right: 5px

    span.newValue
      color: #7F98A5
      font-weight: 600
      margin-left: 5px

.ui.dropdown > .dropdown.icon:before
  content: '\f11c' !important
  font-family: "Font Awesome 5 Free"
  font-weight: 300
  font-size: 16px
  color: #ACC3CF

.ui.default.dropdown:not(.button) > .text, .ui.dropdown:not(.button) > .default.text
  color: #ACC3CF !important
</style>
